var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C5.72727 0 1.65136 2.66858 0 6.43548C1.65136 10.2024 5.72727 12.871 10.5 12.871C15.2727 12.871 19.3486 10.2024 21 6.43548C19.3486 2.66858 15.2727 0 10.5 0ZM10.5 10.7258C7.86545 10.7258 5.72727 8.80374 5.72727 6.43548C5.72727 4.06723 7.86545 2.14516 10.5 2.14516C13.1345 2.14516 15.2727 4.06723 15.2727 6.43548C15.2727 8.80374 13.1345 10.7258 10.5 10.7258ZM10.5 3.86129C8.91545 3.86129 7.63636 5.0111 7.63636 6.43548C7.63636 7.85987 8.91545 9.00968 10.5 9.00968C12.0845 9.00968 13.3636 7.85987 13.3636 6.43548C13.3636 5.0111 12.0845 3.86129 10.5 3.86129Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.af617faf2bab2643edaaa6e31180af3d.svg";
export { ForwardRef as ReactComponent };